import React from "react";
import CompanyBlock from "../CompanyBlock/CompanyBlock";
import Navigation from "./Navigations/Navigation";
import "./Sidebar.scss";

const Sidebar = () => {
  return (
    <nav className="sidebar">
      <CompanyBlock />
      <Navigation />
    </nav>
  );
};
export default Sidebar;
